module.exports = __webpack_public_path__ + "static/Khoury-bf55fbe9d21790fc7513c3ce48cc15fe.png";